<template>
  <div style="text-align: center;">
    <el-checkbox-group size="mini" v-model="current" @change="handleRouter()">
      <el-checkbox-button style="font-size: 18px"
                          :label="1" :key="1" @click="handleRouter('')">
        <i class="el-icon-edit" v-if="computedType(1)"></i>
        服饰
      </el-checkbox-button>
      <el-checkbox-button @click="handleRouter('')"
                          :label="2" :key="2" style="font-size: 18px;">
        <i class="el-icon-edit" v-if="computedType(2)"></i>
        美护
      </el-checkbox-button>
      <el-checkbox-button @click="handleRouter('')"
                          :key="3"      :label="3" style="font-size: 18px">
        <i class="el-icon-edit" v-if="computedType(3)"></i>
        视频号
      </el-checkbox-button>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'navBar',
  props: {
    isType: {
      type: Number,
      required: true,
      default: function () {
        //美护：1  /服饰：2  /视频号：3
        return 1
      }
    },
    categoryType:{
      type: [Number,String],
      required: true,
      default: function () {
        //1:选品  2：直播
        return 1
      }
    }
  },
  data() {
    return {
      current: [1],
    }
  },
  mounted() {
    this.current = [this.isType]
  },
  methods: {
    handleRouter() {
      const index = this.current[this.current.length-1]
      const type = Number(this.categoryType)
      const params = {
        id: this.$route.params.id,
        categoryType: type
      }
      let name = null
      if (type === 1) {
        switch (index) {
          case 1:
            name = 'productDressKol'
            break;
          case 2:
            name = 'lbKolDetail'
            break;
          case 3:
            name = 'productVideoKol'
            break;
        }

      }else {
        switch (index) {
          case 1:
            name = 'productDressLive'
            break;
          case 2:
            name = 'lbLiveDetail'
            break;
          case 3:
            name = 'productVideoLive'
            break;
        }

      }

      const {href} = this.$router.resolve({
        name: name,
        params: params
      })
      window.open(href, '_self')
      this.current=[this.isType]
    },
    computedType(value) {
      return value === this.isType
    }

  }
}
</script>
